export const isOfType = <T>(
  varToBeChecked: unknown,
  propertyToCheckFor: keyof T
): varToBeChecked is T => {
  if (varToBeChecked === undefined || varToBeChecked === null) {
    return false;
  }
  return (varToBeChecked as T)[propertyToCheckFor] !== undefined;
};
